import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { tap } from 'rxjs';

export const updateIdempotentKeyInterceptor: HttpInterceptorFn = (req, next) => {
   return next(req).pipe(
      tap((event) => {
         if (event instanceof HttpResponse) {
            if (event.status >= 200 && event.status < 300) {
               const key = uuidv4();
               localStorage.setItem(
                  environment.idempotentStorageKeyName,
                  JSON.stringify(key)
               );
            }
         }
      })
   );
};
